<template>
  <FilterOverview :showFilterInitially="false" :title="title" @reload="onReload">
    <template #toolbar-left>
      <div class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
        <slot name="my-overview"></slot>
        <b-form-checkbox
          v-model="lastAbfrageCheckbox"
          class="mr-5"
          @change="gridApi.onFilterChanged()"
          switch
        >
          Letzte Abfrage
        </b-form-checkbox>
        <b-form-checkbox
          class="mr-5"
          v-model="regionsmanagerAnsichtCheckbox"
          @change="regionsmanagerAnsichtChanged"
          switch
        >
          Meine Reisen
        </b-form-checkbox>
        <RegionFilterButtonGroup
          :regions="['Amerika', 'Afrika', 'Asien', 'Orient', 'Ozeanien', 'Nordeuropa', 'Südeuropa']"
          :disabled="regionFilterDisabled"
          v-model="selectedRegions"
          :width="520"
        ></RegionFilterButtonGroup>

        <!-- Filter Reset Button -->
        <div
          v-if="isFilterSupplied"
          class="icon-button d-flex justify-content-center text-danger mr-4 ml-2"
          style="width: 36px; min-width: 36px"
          @click="resetAllFilters"
          v-b-tooltip.hover.bottom
          title="Filter zurücksetzen"
        >
          <span class="d-flex align-items-center"><FunnelX :size="20" /></span>
        </div>
      </div>
    </template>
    <template #toolbar-right>
      <b-button size="sm" variant="primary" class="dialog-btn mr-2" @click="onButtonExport">Export</b-button>

      <MultipleEditModalFVC
        @bulkUpdateSuccess="successfulBulkUpdate"
        :ids="allSelectedRows.map(row => row.data.id).flat()"
        :stati="allSelectedRows.map(row => row.data.status).flat()"
      ></MultipleEditModalFVC>

      <b-dropdown
        right
        text="..."
        no-caret
        size="sm"
        v-if="allSelectedRows.length > 0"
        class="mr-3"
        toggle-class="dialog-btn-secondary"
      >
        <b-dropdown-item size="sm" v-b-modal.multipleEditModal v-if="allSelectedRows.length > 1">
          Markierte ABFHT bearbeiten
        </b-dropdown-item>
        <b-dropdown-item @click="openAufgabenModalWithData">Aufgabe erstellen</b-dropdown-item>

        <!-- <b-dropdown-item v-allowedRoles="[Role.ADMIN, Role.YIELD]">Markierte ABFHT löschen</b-dropdown-item> -->
      </b-dropdown>
    </template>

    <template #table="{ tableHeight }">
      <AgGridVue
        :style="{ height: tableHeight + 87 + 'px' }"
        class="ag-theme-alpine m-0 p-0"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowModelType="rowModelType"
        :sideBar="sideBar"
        :getRowHeight="getRowHeight"
        :statusBar="statusBar"
        suppressRowTransform
        :rowSelection="rowSelection"
        :rowMultiSelectWithClick="rowMultiSelectWithClick"
        :tooltipShowDelay="tooltipShowDelay"
        :tooltipMouseTrack="true"
        :enableCellTextSelection="true"
        suppressContextMenu
        @grid-ready="onGridReady"
        @rowDoubleClicked="collapseSidebarAndLoadData"
        @rowSelected="onRowSelected"
        suppressCellFocus
      ></AgGridVue>
      <AufgabeErstellenModal
        @aufgabeErstellt="onAufgabeErstelltFromFVC"
        :prefixedVerlinkungen="prefixedVerlinkungen"
        :disableAttachments="true"
        :fromFVC="true"
        :enableManualTask="true"
      ></AufgabeErstellenModal>
      <SidebarDetails
        :lastAbfrage="lastAbfrage"
        @rowSelectionChanged="changeRowSelection"
        @openAufgabeErstellenModal="openAufgabeErstellenModal"
        @dataChangeSuccessful="updateChangedRow"
        @hidden="resetPrefixedVerlinkungen"
      ></SidebarDetails>
    </template>
  </FilterOverview>
</template>
<script>
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-enterprise';
import * as applicationInsights from '@/core/common/services/application-insights.service';
import AufgabeErstellenModal from '@/components/aufgaben/aufgabe-erstellen-modal.vue';
import { add } from 'date-fns';
import AgDateRangePicker from '@/components/flugverfuegbarkeit/ag-date-range-picker.vue';
import FilterOverview from '@/components/common/filter-overview.vue';
import CellRendererPrioritaet from '@/components/flugverfuegbarkeit/cell-renderer-prioritaet.vue';
import CellRendererStatus from '@/components/flugverfuegbarkeit/cell-renderer-status.vue';
import FilterRendererFarben from '@/components/flugverfuegbarkeit/filter-renderer-farben.vue';
import StatusBarComponent from '@/components/flugverfuegbarkeit/status-bar-ag-grid.vue';
import {
  RESET_EDITED_FILTER,
  SET_EDITED_FILTER,
  GET_SINGLE_FLUGVERFUEGBARKEIT,
  SET_DETAILDATA,
  SET_LAST_ABFRAGEDATE,
  RESET_LAST_ABFRAGEDATE,
  GET_FLUGVERFUEGBARKEIT,
  SET_FLUGVERFUEGBARKEIT_SKIP,
  GET_FLUGPLANUNGSDATA,
  SET_FLUGVERFUEGBARKEIT_ORDER_BY,
  GET_LAST_ABFRAGE,
  GET_INFO_DATA,
} from '@/core/flugverfuegbarkeit/stores/flugverfuegbarkeit.module';
import {
  fvcHeaderRow,
  fvcSelectedFlugverfügbarkeitVariables,
  fvcExpandConfig,
  createExcelExport,
} from '@/core/common/helpers/exportHelper';

import { mapState, mapGetters } from 'vuex';
import {
  calculateLastSaturday,
  getRegionsmanagerById,
  formatDateWithoutHours,
} from '@/core/common/helpers/utils';
import {
  bearbeitungsFarben,
  garantiertFilterRenderer,
  dateFormatterStandard,
  fehlertypen,
  dateFormatterWithHours,
  zimmertypen,
} from '@/core/flugverfuegbarkeit/yield-table-config.js';
import CustomHeader from '@/components/flugverfuegbarkeit/custom-header.vue';
import SidebarDetails from '@/components/flugverfuegbarkeit/sidebar-details.vue';
import CustomTooltip from '@/components/flugverfuegbarkeit/custom-tooltip.vue';
import CellRendererPax from '@/components/produkte/reisetermine/cell-renderer-pax.vue';
import regionsmanagerConfig from '@/core/flugverfuegbarkeit/regionsmanager-reisekuerzel.json';
import MultipleEditModalFVC from '@/components/flugverfuegbarkeit/multiple-edit-modal.vue';
import CellRendererAufgaben from '@/components/produkte/reisetermine/cell-renderer-aufgaben.vue';
import { allAkzeptanzgruende, allUrsachen } from '@/core/flugverfuegbarkeit/bearbeitungs-options.config.js';
import { differenceInDays, parseISO, format } from 'date-fns';
import { getRegionsmanagerOfReisekuerzel } from '@/core/common/helpers/utils.js';
import RegionFilterButtonGroup from '@/components/common/region-filter-button-group.vue';
import CustomInfoIconHeader from '@/components/common/custom-info-icon-header.vue';
import { einkaufsartOptions, translateEinkaufsartOptions } from '@/core/common/helpers/utils.js';
import * as odataService from '@/core/common/services/odata.service';
import { getOdataFilterFromAgGridRequest } from '@/core/flugverfuegbarkeit/stores/flugverfuegbarkeit.module';
import { FunnelX } from 'lucide-vue';

export default {
  name: 'App',
  components: {
    AgGridVue,
    FilterOverview,
    AgDateRangePicker,
    StatusBarComponent,
    AufgabeErstellenModal,
    SidebarDetails,
    CellRendererPax,
    FilterRendererFarben,
    CellRendererStatus,
    agColumnHeader: CustomHeader,
    CellRendererPrioritaet,
    CustomTooltip,
    MultipleEditModalFVC,
    CellRendererAufgaben,
    RegionFilterButtonGroup,
    CustomInfoIconHeader: CustomInfoIconHeader,
    FunnelX,
  },
  props: {
    title: { type: String, default: 'FVC-Übersicht' },
    showingMyOverview: { type: Boolean, default: false },
  },
  data() {
    return {
      lastOdataFilter: null,
      isFilterSupplied: false,
      isManuallyEditedFilter: false,
      isAutomaticallyEditedFilter: false,
      lastAbfrageCheckbox: true,
      regionsmanagerAnsichtCheckbox: false,
      columnDefs: null,
      statusBar: null,
      gridApi: null,
      columnApi: null,
      prefixedVerlinkungen: [],
      REGION_MANAGERS: regionsmanagerConfig,
      defaultColDef: {
        floatingFilter: true,
        filter: true,
        flex: 1,
        resizable: false,
        sortable: false,
        suppressMenu: true,
        floatingFilterComponentParams: {
          suppressFilterButton: true,
        },
        suppressMovable: true,
        filterParams: {
          defaultToNothingSelected: true,
        },
        tooltipComponent: 'CustomTooltip',
      },
      tooltipShowDelay: 0,
      sideBar: null,
      rowModelType: null,
      rowSelection: null,
      selectedRowID: null,
      rowMultiSelectWithClick: null,
      allSelectedRows: [],
      selectedRegions: [],
      regionFilterSelected: null,
      regionFilterDisabled: true,
    };
  },
  watch: {
    // schaut auf das array "selectedRegions" und dessen veränderung
    selectedRegions(newSelectedRegions) {
      // und geben das newSelectedRegions aus dem emit in die methode
      this.changeRegionFilterInstance(newSelectedRegions);
    },
  },
  created() {
    this.columnDefs = [
      {
        field: 'farben',
        headerName: '',
        minWidth: 50,
        width: 50,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: bearbeitungsFarben.map(item => item.value),
          valueFormatter: params => bearbeitungsFarben.find(item => item.value === params.value)?.label,
          debounceMs: 1000,
          cellRenderer: 'FilterRendererFarben',
          comparator: (a, b) => {
            if (a === 'null') return 1;
            else if (a === b) return 0;
            return a > b ? 1 : -1;
          },
        },
        floatingFilter: true,
        pinned: 'left',
        cellRenderer: params => {
          if (params.data.bearbeitungStatus === 'Akzeptiert') {
            // &nbsp; benutzt, da das "leere"-Div nicht angezeigt wird -> es wird ein "leerzeichen" eingesetzt
            return '<div style="width: 5px; height: 100%; background-color: #0088FF">&nbsp;</div>';
          } else if (params.data.bearbeitungStatus === 'VerfuegbarkeitGeschaffen') {
            return '<div style="width: 5px; height:100%; background-color:#1bc5bd">&nbsp;</div>';
          } else if (params.data.bearbeitungStatus === 'VerfuegbarkeitNichtGeschaffen') {
            return '<div style="width: 5px; height:100%; background-color:#F64E60">&nbsp;</div>';
          }
        },
      },
      {
        field: 'bearbeitung',
        headerName: '',
        pinned: 'left',
        sortable: false,
        filter: 'agSetColumnFilter',
        floatingFilter: true,
        filterParams: {
          values: ['Automatisch bearbeitet', 'Manuell bearbeitet'],
          debounceMs: 1000,
        },
        width: 50,
        minWidth: 50,
        cellRenderer: params => {
          // automatisch bearbeitet
          if (params.data.lastModifiedUserId === null && params.data.bearbeitungStatus !== null) {
            return '<span>🤖</span>';
          } else return '';
        },
      },
      {
        field: 'reisetermin.istZusatztermin',
        cellRenderer: params => {
          if (params.value) {
            return 'Z';
          }
          return '';
        },
        filterParams: {
          values: [true, false],
          valueFormatter: params =>
            params.value === true
              ? 'Zusatztermin'
              : params.value === false
              ? 'Kein Zusatztermin'
              : params.value,
        },
        headerName: '',
        pinned: 'left',
        width: 80,
        minWidth: 80,
      },
      {
        field: 'reisetermin.reise.reisekuerzel',
        headerCheckboxSelection: true,
        sortable: true,
        headerName: 'Reisekürzel',
        filter: 'agSetColumnFilter',
        floatingFilter: true,
        checkboxSelection: true,
        width: 170,
        minWidth: 170,
        filterParams: {
          values: params => params.success(this.reisekuerzelOptions.map(r => r.reisekuerzel)),
          debounceMs: 1000,
        },
        pinned: 'left',
      },
      {
        field: 'reisetermin.abreisedatum',
        sortable: false,
        headerName: 'Abreisedatum',
        valueFormatter: dateFormatterStandard,
        minWidth: 190,
        width: 190,
        floatingFilterComponent: 'AgDateRangePicker',
        floatingFilterComponentParams: {
          isChild: true,
        },
        filter: 'AgDateRangePicker',
        floatingFilter: true,
        pinned: 'left',
      },
      {
        field: 'reisetermin.hotelendUndRueckflugdatum',
        sortable: true,
        headerName: 'Rückflugdatum',
        valueFormatter: dateFormatterStandard,
        minWidth: 190,
        width: 190,
        floatingFilterComponent: 'AgDateRangePicker',
        floatingFilterComponentParams: {
          isChild: true,
        },
        filter: 'AgDateRangePicker',
        floatingFilter: true,
        pinned: 'left',
      },
      {
        field: 'deutscherAbflughafenIataCode',
        sortable: true,
        headerName: 'ABFH',
        width: 100,
        headerTooltip: 'Deutscher Abflughafen',
        filter: 'agSetColumnFilter',
        filterParams: {
          values: ['BER', 'DUS', 'FRA', 'HAM', 'MUC', 'VIE', 'ZRH'],
          debounceMs: 1000,
        },
        floatingFilter: true,
        pinned: 'left',
      },
      {
        field: 'status',
        headerName: 'Status',
        width: 100,
        sortable: false,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: ['NichtVerfuegbar', 'Verfuegbar<200', 'AufAnfrage', 'Verfuegbar>200'],
          debounceMs: 1000,
          cellRenderer: 'CellRendererStatus',
          cellRendererParams: { isFilterRenderer: true },
        },
        floatingFilterComponentParams: {
          isFilterParam: true,
        },
        pinned: 'left',
        cellRenderer: 'CellRendererStatus',
        minWidth: 100,
      },

      {
        field: 'aufpreis',
        sortable: true,
        headerName: 'Aufpreis',
        headerTooltip: 'Aufpreis = VK - Basispreis - EZZ - optionaler Flugaufpreis',
        cellRenderer: params => {
          if (params.value !== null) {
            // Aufpreis über 200€ gilt als kritisch (rot), bis einschließlich 200€ als unkritisch (grün)
            if (params.value > 200) {
              return `<span class="kachel-badge red">${params.value}€</span>`;
            } else if (params.value <= 200) {
              return `<span class="kachel-badge green">${params.value}€</span>`;
            }
          }
        },
        filter: 'agSetColumnFilter',
        filterParams: {
          values: ['<0€', '0€', '0-100€', '100-200€', '>200€'],
          debounceMs: 1000,
          comparator: (a, b) => (a === '0€' ? 1 : a < b),
        },
        pinned: 'left',
        minWidth: 120,
        width: 120,
        floatingFilter: true,
      },
      {
        field: 'reisetermin.reise.prioritaet',
        headerName: 'Priorität',
        filter: 'agSetColumnFilter',
        width: 120,
        minWidth: 120,
        sortable: true,
        filterParams: {
          values: [0, 1, 2, 3],
          debounceMs: 1000,
          cellRenderer: 'CellRendererPrioritaet',
          cellRendererParams: { isFilterRenderer: true },
        },
        floatingFilter: true,
        cellRenderer: 'CellRendererPrioritaet',
      },
      {
        field: 'reisetermin.umsatzpotenzial',
        headerName: 'Umsatzpotenzial',
        headerComponent: 'CustomInfoIconHeader',
        headerComponentParams: {
          hoverText: 'Zum Filtern kann eine Zahl, eine Range oder </> für die Suche eingegeben werden.',
        },
        headerTooltip: '(Erw. Pax - Ist Pax) * Basispreis (p.P im DZ)',
        cellRenderer: params =>
          params.data.reisetermin.umsatzpotenzial
            ? new Intl.NumberFormat('en-DE').format(params.data.reisetermin.umsatzpotenzial) + '€'
            : '-',
        filter: 'agTextColumnFilter',
        filterParams: {
          buttons: ['apply'],
        },
        minWidth: 180,
        width: 180,
      },
      {
        field: 'reisetermin.metadata.transferszenarioHin',
        headerName: 'TS Hin',
        headerTooltip: 'Transferszenario',
        minWidth: 100,
        width: 100,
        sortable: true,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: ['T3_unbegr_inkl', 'T4_unbegr_exkl', 'TX_ohne', 'TS'],
          valueFormatter: params => {
            return params.value?.substring(0, 2);
          },
          debounceMs: 1000,
          comparator: (a, b) => (a === '0€' ? 1 : a < b),
        },
        floatingFilter: true,
        cellRenderer: params => {
          return params.value?.substring(0, 2);
        },
      },
      {
        field: 'reisetermin.metadata.transferszenarioRueck',
        headerName: 'TS Rück',
        headerTooltip: 'Transferszenario',
        minWidth: 110,
        width: 110,
        sortable: true,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: ['T3_unbegr_inkl', 'T4_unbegr_exkl', 'TX_ohne', 'TS'],
          valueFormatter: params => {
            return params.value?.substring(0, 2);
          },
          debounceMs: 1000,
          comparator: (a, b) => (a === '0€' ? 1 : a < b),
        },
        floatingFilter: true,
        cellRenderer: params => {
          return params.value?.substring(0, 2);
        },
      },
      {
        field: 'abfragefehler.typ',
        sortable: true,
        headerName: 'Fehlermeldung',
        minWidth: 165,
        filter: 'agSetColumnFilter',
        floatingFilter: true,
        filterParams: {
          values: fehlertypen,
          valueFormatter: params => params.value.replaceAll('_', ' '),
          debounceMs: 1000,
        },
        tooltipField: 'abfragefehler.text',
        cellRenderer: params => {
          if (params.value) {
            const firstTenLetters = params.value.substring(0, 14).replaceAll('_', ' ');
            const cellValue = firstTenLetters + '...';
            return cellValue;
          }
        },
      },
      {
        field: 'flugstammHinflug',
        sortable: true,
        headerName: 'Flugstamm Hin',
        filter: 'agTextColumnFilter',
        minWidth: 170,
        filterParams: {
          buttons: ['apply'],
        },
      },
      {
        field: 'zielflughafenIataCode',
        sortable: false,
        headerName: 'Hin-Nach',
        headerTooltip: 'Zielland Zielflughafen',
        width: 105,
        minWidth: 105,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          buttons: ['apply'],
        },
      },
      {
        field: 'abflughafenIataCode',
        sortable: false,
        headerName: 'Rück-Von',
        width: 105,
        minWidth: 105,
        headerTooltip: 'Zielland Abflughafen',
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          buttons: ['apply'],
        },
      },
      {
        field: 'reisetermin/pax/ist',
        headerName: 'PAX',
        headerComponent: 'CustomInfoIconHeader',
        headerComponentParams: {
          hoverText: 'Zum Filtern kann eine Zahl, eine Range oder </> für die Suche eingegeben werden.',
        },
        cellRenderer: 'CellRendererPax',
        filter: 'agTextColumnFilter',
        filterParams: {
          buttons: ['apply'],
        },
        minWidth: 175,
        width: 175,
        suppressRowTransform: true,
        cellStyle: {
          'line-height': 'normal',
          display: 'flex',
          'justify-items': 'center',
          overflow: 'visible',
          'align-items': 'center',
        },
        cellRendererParams: params => ({
          paxObject: params.data.reisetermin.pax,
          minPax: params.data.reisetermin.metadata.minPax,
          maxPax: params.data.reisetermin.metadata.maxPax,
          kalkPax: params.data.reisetermin.metadata.kalkPax,
          forecastPax: params.data.reisetermin.metadata.forecastPax,
          durchfuehrbareMinPax: params.data.reisetermin.metadata.durchfuehrbareMinPax,
          id: params.data.id,
        }),
      },
      {
        field: 'reisetermin.garantiert',
        sortable: true,
        headerName: 'Gar.',

        cellRenderer: params => {
          const { value } = params;
          if (value) {
            return "<i class='fas fa-check text-success fa-lg'/>";
          } else {
            return "<i class='ml-1 fas fa-times text-danger fa-lg'/>";
          }
        },
        filter: 'agSetColumnFilter',
        filterParams: {
          values: [true, false],
          cellRenderer: garantiertFilterRenderer,
          debounceMs: 1000,
        },
        minWidth: 70,
        width: 70,
      },
      {
        field: 'reisetermin.flugeinkauf.einkaufsart',
        headerName: 'Einkaufsart',
        minWidth: 120,
        width: 120,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: einkaufsartOptions.map(option => option.value),
          valueFormatter: params => translateEinkaufsartOptions(params.value),
        },
        cellRenderer: params => translateEinkaufsartOptions(params.value),
        tooltipValueGetter: params => translateEinkaufsartOptions(params.value),
      },
      {
        field: 'reisetermin.releasedatum',
        sortable: true,
        headerName: 'Tage bis Release',
        minWidth: 170,
        width: 170,
        cellRenderer: params => {
          const daysUntilRelease = differenceInDays(parseISO(params.value), new Date());
          return daysUntilRelease;
        },
        floatingFilter: false,
      },
      {
        field: 'reisetermin.thLangstrecke',
        headerName: 'TH Langstrecke',
        headerComponent: 'CustomInfoIconHeader',
        headerComponentParams: {
          hoverText: 'Zum Filtern kann eine Zahl, eine Range oder </> für die Suche eingegeben werden.',
        },
        filter: 'agTextColumnFilter',
        filterParams: { buttons: ['apply'] },
        cellRenderer: params => (params.value ? params.value + '€' : '-'),
        width: 145,
        minWidth: 145,
      },
      {
        field: 'reisetermin.gueltigerSaisonpreis.thMaxLangstrecke',
        headerName: 'TH Max Langstrecke',
        headerComponent: 'CustomInfoIconHeader',
        headerComponentParams: {
          hoverText: 'Zum Filtern kann eine Zahl, eine Range oder </> für die Suche eingegeben werden.',
        },
        cellRenderer: params =>
          params.data.reisetermin.gueltigerSaisonpreis != null
            ? params.data.reisetermin.gueltigerSaisonpreis.thMaxLangstrecke + '€'
            : '-',
        cellStyle: params => {
          if (
            params.data?.reisetermin?.gueltigerSaisonpreis?.thMaxLangstrecke !== null &&
            params.data?.reisetermin?.thLangstrecke !== null &&
            params.data.reisetermin.gueltigerSaisonpreis?.thMaxLangstrecke >
              params.data.reisetermin.thLangstrecke
          ) {
            return { color: 'green' };
          }
          if (
            params.data?.reisetermin?.gueltigerSaisonpreis?.thMaxLangstrecke !== null &&
            params.data?.reisetermin?.thLangstrecke !== null &&
            params.data.reisetermin.gueltigerSaisonpreis?.thMaxLangstrecke <
              params.data.reisetermin.thLangstrecke
          ) {
            return { color: 'red' };
          }

          return null;
        },
        filter: 'agTextColumnFilter',
        filterParams: { buttons: ['apply'] },
        width: 185,
        minWidth: 185,
      },
      {
        field: 'zimmertyp',
        sortable: false,
        minWidth: 120,
        width: 120,
        headerName: 'Zimmertyp',
        filter: 'agSetColumnFilter',
        filterParams: {
          values: zimmertypen,
          debounceMs: 1000,
        },
        floatingFilter: true,
      },
      {
        field: 'regionsmanager',
        headerName: 'RM',
        headerTooltip: 'Regionsmanager',
        filter: 'agSetColumnFilter',
        filterParams: { values: ['STGE', 'SYKE'], debounceMs: 1000 },
        minWidth: 90,
        width: 90,
        floatingFilter: true,
        cellRenderer: params => {
          const { reisekuerzel } = params.data.reisetermin.reise;
          const responsibleManagers = getRegionsmanagerOfReisekuerzel(reisekuerzel);
          return responsibleManagers;
        },
      },
      {
        field: 'abfragedatum',
        headerName: 'Abfragedatum',
        valueFormatter: dateFormatterWithHours,
        floatingFilterComponent: 'AgDateRangePicker',
        floatingFilterComponentParams: {
          isChild: true,
        },
        filter: 'AgDateRangePicker',
        floatingFilter: true,
        minWidth: 190,
        width: 190,
      },
      {
        field: 'blankImportedDateUtc',
        headerName: 'Zuletzt abgefragt',
        valueFormatter: dateFormatterWithHours,
        floatingFilterComponent: 'AgDateRangePicker',
        floatingFilterComponentParams: {
          isChild: true,
        },
        filter: 'AgDateRangePicker',
        floatingFilter: true,
        minWidth: 190,
        width: 190,
      },
      {
        field: 'akzeptanzgrund',
        headerName: 'Akzeptanzgrund',
        filter: 'agSetColumnFilter',
        valueFormatter: params =>
          allAkzeptanzgruende.find(akzeptanzgrund => akzeptanzgrund.enum === params.value)?.label,
        filterParams: {
          values: allAkzeptanzgruende.map(akzeptanzgrund => akzeptanzgrund.enum),
          debounceMs: 1000,
          valueFormatter: params =>
            allAkzeptanzgruende.find(akzeptanzgrund => akzeptanzgrund.enum === params.value)?.label,
        },
        floatingFilter: true,
        minWidth: 180,
        width: 180,
      },
      {
        field: 'ursache',
        headerName: 'Ursache',
        filter: 'agSetColumnFilter',
        valueFormatter: params => allUrsachen.find(ursache => ursache.enum === params.value)?.label,
        filterParams: {
          values: allUrsachen.map(ursache => ursache.enum),
          debounceMs: 1000,
          valueFormatter: params => allUrsachen.find(ursache => ursache.enum === params.value)?.label,
        },
        floatingFilter: true,
        minWidth: 180,
        width: 180,
      },
      {
        field: 'aufgaben',
        headerName: 'Aufgaben',
        cellRenderer: 'CellRendererAufgaben',
        floatingFilter: false,
        cellRendererParams: { filter: 'fvc', ansicht: 'fvc-overview' },
        minWidth: 500,
        width: 500,
        cellStyle: {
          'line-height': 'normal',
          display: 'flex',
          'align-items': 'center',
        },
      },
      {
        field: 'reisetermin.reise.region',
        headerName: 'Region',
        filter: 'agSetColumnFilter',
        width: 100,
        minWidth: 100,
        filterParams: {
          values: ['Amerika', 'Afrika', 'Asien', 'Orient', 'Ozeanien', 'Nordeuropa', 'Südeuropa'],
          debounceMs: 1000,
        },
        hide: true,
      },
      {
        field: 'id',
        hide: true,
        filter: 'agTextColumnFilter',
      },
      {
        field: 'reisekuerzelPrefilled',
        hide: true,
        filter: 'agTextColumnFilter',
      },
    ];
    this.rowModelType = 'serverSide';
    this.statusBar = {
      statusPanels: [{ statusPanel: 'StatusBarComponent', key: 'statusBarCompKey', align: 'left' }],
    };
    this.rowSelection = 'multiple';
    this.rowMultiSelectWithClick = true;
  },
  computed: {
    ...mapState({
      lastAbfrage: state => state.flugverfuegbarkeit.lastAbfrage,
      flugverfuegbarkeit: state => state.flugverfuegbarkeit.flugverfuegbarkeit,
      count: state => state.flugverfuegbarkeit.count,
      reisekuerzelOptions: state => state.reisen.reisenkuerzelFilterOptions,
    }),
    ...mapGetters(['currentUserName', 'parsedRoles', 'currentUserId']),
  },
  methods: {
    openAufgabenModalWithData() {
      this.prefixedVerlinkungen = this.allSelectedRows.map((item, i) => ({
        id: i,
        typ: 'Flugverfügbarkeit',
        artifactId: item.data.id,
        artifactText: null,
      }));

      this.$bvModal.show('modalAufgabeEdit');
    },
    onReload() {
      this.gridApi.onFilterChanged();
    },
    getRowHeight(params) {
      return params.data ? Math.max(1, params.data.aufgaben?.length) * 50 : 50;
    },
    onAufgabeErstelltFromFVC(type) {
      if (type === 'single') {
        this.collapseSidebar();
      } else if (type === 'bulk') {
        this.$bvModal.hide('multipleEditModal');
      }
      this.gridApi?.deselectAll();
      this.gridApi.onFilterChanged();
    },
    resetPrefixedVerlinkungen() {
      this.prefixedVerlinkungen = [];
    },
    openAufgabeErstellenModal(verlinkung) {
      this.prefixedVerlinkungen = verlinkung;
    },
    resetAllFilters() {
      this.gridApi.setFilterModel(null);
      let filterDate1 = this.gridApi.getFilterInstance('reisetermin.abreisedatum');
      let filterDate2 = this.gridApi.getFilterInstance('reisetermin.hotelendUndRueckflugdatum');
      let filterDate3 = this.gridApi.getFilterInstance('abfragedatum');
      filterDate1.onDateRangeFilterChanged(null);
      filterDate2.onDateRangeFilterChanged(null);
      filterDate3.onDateRangeFilterChanged(null);
      this.selectedRegions = [];
    },

    async onButtonExport() {
      // Das aktuelle Filter-Modell vom Grid holen
      const filterModel = this.gridApi?.getFilterModel() || {};
      const gridRequest = { filterModel };

      // state aus dem Vuex-Store holen zb. Filter
      const storeState = this.$store.state.flugverfuegbarkeit;
      const exportFilter = getOdataFilterFromAgGridRequest(storeState, gridRequest);

      await createExcelExport({
        headerRow: fvcHeaderRow,
        fetchData: async () =>
          await odataService.getFlugverfuegbarkeit({
            filter: exportFilter,
            expand: fvcExpandConfig,
            select: fvcSelectedFlugverfügbarkeitVariables,
            count: true,
            orderBy: 'reisetermin/abreisedatum asc',
          }),
        createRowData: this.createRowData,
        sheetName: 'FVC',
        fileNamePrefix: 'FVC_Export',
      });
    },

    checkIfFilterSupplied() {
      this.isFilterSupplied = this.gridApi && Object.keys(this.gridApi?.getFilterModel()).length > 0;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

      if (this.$route.query.id) {
        const idFilter = this.gridApi?.getFilterInstance('id');
        if (!isNaN(this.$route.query.id))
          idFilter.setModel({ filterType: 'text', filter: this.$route.query.id });
      } else {
        if (this.$route.query.abreisedatum) {
          const abreisedatumFilter = this.gridApi?.getFilterInstance('reisetermin.abreisedatum');
          abreisedatumFilter.setModel({
            dateFrom: this.$route.query.abreisedatum,
            dateTo: add(new Date(this.$route.query.abreisedatum), { days: 1 }),
            filterType: 'date',
            type: 'inRange',
          });
        }
        if (this.$route.query.deutscherAbflughafen) {
          const deutscherAbflughafen = this.gridApi?.getFilterInstance('deutscherAbflughafenIataCode');
          deutscherAbflughafen.setModel({
            values: [this.$route.query.deutscherAbflughafen],
            filter: 'set',
          });
        }
        if (this.$route.query.reise) {
          const reiseFilter = this.gridApi?.getFilterInstance('reisekuerzelPrefilled');
          reiseFilter.setModel({ filterType: 'text', filter: this.$route.query.reise, type: 'contains' });
          this.gridApi.onFilterChanged();
        }
      }

      const updateData = () => {
        const server = this.server();
        const datasource = this.createServerSideDatasource(server);
        // register the datasource with the grid
        params.api.setServerSideDatasource(datasource);
      };

      updateData();
    },
    createServerSideDatasource(server) {
      return {
        getRows: async params => {
          console.log('[Datasource] - rows requested by grid: ', params.request);

          const response = await server.getData(params.request);
          if (response.success) {
            // supply rows for requested block to grid
            params.success({ rowData: response.rows });
            this.updateStatusBar(this.gridApi?.getDisplayedRowCount());
            if (this.$route.query.id && !isNaN(this.$route.query.id)) {
              this.selectedRowID = 0;
              let data;
              this.gridApi.forEachNode(rowNode => {
                if (rowNode.rowIndex === 0) {
                  rowNode.setSelected(true);
                  data = rowNode.data;
                }
              });
              this.queryLastAbfrage(data);
              this.$store.commit('flugverfuegbarkeit/' + SET_DETAILDATA, data);
              if (new Date(data?.reisetermin?.startdatum).getFullYear() === 2024) {
                this.$store.dispatch(
                  'flugverfuegbarkeit/' + GET_FLUGPLANUNGSDATA,
                  data.reisetermin.reiseterminkuerzel
                );
              }
              this.$store.dispatch('flugverfuegbarkeit/' + GET_INFO_DATA, data.id);
              this.collapseSidebar();
            }
          } else {
            params.fail();
          }
        },
      };
    },
    server() {
      return {
        getData: async request => {
          this.setFilters(request);
          this.lastOdataFilter = this.setFilters(request);

          const usedFilters = Object.keys(request.filterModel);
          if (usedFilters.length > 0) {
            usedFilters.forEach(filterName => {
              applicationInsights.trackEventWithRouteAndUser(
                { name: `Applied FVC Overview filter ${filterName}` },
                {
                  roles: this.parsedRoles,
                  currentUserName: this.currentUserName,
                }
              );
            });
          }
          const response = await this.$store.dispatch(
            'flugverfuegbarkeit/' + GET_FLUGVERFUEGBARKEIT,
            request
          );
          this.regionFilterDisabled = false;
          return {
            success: true,
            rows: response,
          };
        },
      };
    },
    setFilters(request) {
      this.applyEditFilters();
      this.gridApi?.deselectAll();
      this.checkIfFilterSupplied();

      // Apply checkbox
      if (this.lastAbfrageCheckbox) {
        const lastSaturdayDate = calculateLastSaturday();
        this.$store.commit('flugverfuegbarkeit/' + SET_LAST_ABFRAGEDATE, lastSaturdayDate);
      } else {
        this.$store.commit('flugverfuegbarkeit/' + RESET_LAST_ABFRAGEDATE);
      }
      // Apply sorting
      if (request.sortModel.length > 0) {
        // Compose sort string and replace dots with slashes for query
        const sortValues = [
          { ...request.sortModel[0], sortIndex: 0 },
          { colId: 'reisetermin.abreisedatum', sort: 'asc', sortIndex: 1 },
          { colId: 'abfragedatum', sort: 'desc', sortIndex: 2 },
        ];
        const sortString = sortValues
          .map(sorter => (sorter.colId + ' ' + sorter.sort).replaceAll('.', '/'))
          .join(', ');
        this.$store.commit('flugverfuegbarkeit/' + SET_FLUGVERFUEGBARKEIT_ORDER_BY, sortString);
        this.$store.commit('flugverfuegbarkeit/' + SET_FLUGVERFUEGBARKEIT_SKIP, request.startRow);
      }
      // Reset sorting
      else {
        const sortValues = [
          { colId: 'reisetermin.abreisedatum', sort: 'asc', sortIndex: 0 },
          { colId: 'abfragedatum', sort: 'desc', sortIndex: 1 },
        ];
        const sortString = sortValues
          .map(sorter => (sorter.colId + ' ' + sorter.sort).replaceAll('.', '/'))
          .join(', ');
        this.$store.commit('flugverfuegbarkeit/' + SET_FLUGVERFUEGBARKEIT_ORDER_BY, sortString);
        this.$store.commit('flugverfuegbarkeit/' + SET_FLUGVERFUEGBARKEIT_SKIP, request.startRow);
      }
    },
    updateStatusBar(displayedRowsCount) {
      const statusBarComponent = this.gridApi?.getStatusPanel('statusBarCompKey');
      statusBarComponent?.setRowCount(displayedRowsCount);
      statusBarComponent?.setOdataCount(this.count);
    },
    collapseSidebarAndLoadData($event) {
      this.gridApi?.deselectAll();
      const { data, rowIndex } = $event;
      console.log(data, rowIndex);
      this.selectedRowID = rowIndex;
      this.gridApi.forEachNode(rowNode => {
        if (rowNode.rowIndex === rowIndex) {
          rowNode.setSelected(true);
        }
      });
      this.queryLastAbfrage(data);
      this.$store.commit('flugverfuegbarkeit/' + SET_DETAILDATA, data);
      if (new Date(data?.reisetermin?.startdatum).getFullYear() === 2024) {
        this.$store.dispatch(
          'flugverfuegbarkeit/' + GET_FLUGPLANUNGSDATA,
          data.reisetermin.reiseterminkuerzel
        );
      }
      this.$store.dispatch('flugverfuegbarkeit/' + GET_INFO_DATA, data.id);
      this.collapseSidebar();
    },
    collapseSidebar() {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-backdrop');
    },
    async queryLastAbfrage(data) {
      const {
        reisetermin,
        abfragedatum,
        deutscherAbflughafenIataCode,
        zielflughafenIataCode,
        abflughafenIataCode,
        zimmertyp,
        verpflegung,
      } = data;
      const { reiseterminkuerzel } = reisetermin;
      const formattedAbfragedatum = abfragedatum.substring(0, 10);
      const filter = {
        reiseterminkuerzel,
        deutscherAbflughafenIataCode,
        formattedAbfragedatum,
        zielflughafenIataCode,
        abflughafenIataCode,
        zimmertyp,
        verpflegung,
      };

      this.$store.dispatch('flugverfuegbarkeit/' + GET_LAST_ABFRAGE, filter);
    },
    async updateChangedRow(id) {
      console.log(id, ' id from update changed row');
      const updatedRow = await this.$store.dispatch(
        'flugverfuegbarkeit/' + GET_SINGLE_FLUGVERFUEGBARKEIT,
        id
      );
      this.$store.commit('flugverfuegbarkeit/' + SET_DETAILDATA, updatedRow);

      this.gridApi.forEachNode(rowNode => {
        if (rowNode.data.id === id) {
          rowNode.updateData(updatedRow);
        }
      });
      const params = {
        force: true,
        suppressFlash: false,
      };
      this.gridApi.refreshCells(params);
    },
    async changeRowSelection(direction) {
      const displayedRows = this.gridApi?.getDisplayedRowCount();
      if (direction === 'up') {
        if (this.selectedRowID !== 0) {
          const targetedRowID = this.selectedRowID - 1;
          this.gridApi.forEachNode(rowNode => {
            if (rowNode.rowIndex === targetedRowID) {
              rowNode.setSelected(true, true);
              this.gridApi.ensureIndexVisible(rowNode.rowIndex);
              if (new Date(rowNode.data.reisetermin.startdatum).getFullYear() === 2024) {
                this.$store.dispatch(
                  'flugverfuegbarkeit/' + GET_FLUGPLANUNGSDATA,
                  rowNode.data.reisetermin.reiseterminkuerzel
                );
              }
              this.queryLastAbfrage(rowNode.data);
              this.$store.commit('flugverfuegbarkeit/' + SET_DETAILDATA, rowNode.data);
              this.$store.dispatch('flugverfuegbarkeit/' + GET_INFO_DATA, rowNode.data.id);
              this.selectedRowID = targetedRowID;
            }
          });
        }
      } else if (direction === 'down') {
        if (this.selectedRowID + 1 < displayedRows) {
          const targetedRowID = this.selectedRowID + 1;
          this.gridApi.forEachNode(rowNode => {
            if (rowNode.rowIndex === targetedRowID) {
              rowNode.setSelected(true, true);
              this.gridApi.ensureIndexVisible(rowNode.rowIndex);
              if (new Date(rowNode.data.reisetermin.startdatum).getFullYear() === 2024) {
                this.$store.dispatch(
                  'flugverfuegbarkeit/' + GET_FLUGPLANUNGSDATA,
                  rowNode.data.reisetermin.reiseterminkuerzel
                );
              }
              this.queryLastAbfrage(rowNode.data);
              this.$store.commit('flugverfuegbarkeit/' + SET_DETAILDATA, rowNode.data);
              this.$store.dispatch('flugverfuegbarkeit/' + GET_INFO_DATA, rowNode.data.id);
              this.selectedRowID = targetedRowID;
            }
          });
        }
      }
    },
    queryForUser() {
      const targetUser = getRegionsmanagerById(this.currentUserId);
      // Wenn es den Nutzer in der Config gibt
      if (targetUser) {
        const regionsmanagerFilter = this.gridApi?.getFilterInstance('regionsmanager');
        regionsmanagerFilter.setModel({
          filterType: 'set',
          values: [targetUser.shortname],
        });
      }
      this.gridApi.onFilterChanged();
    },
    onRowSelected($event) {
      this.allSelectedRows = this.getAllSelectedRows();
      const statusBarComponent = this.gridApi?.getStatusPanel('statusBarCompKey');
      statusBarComponent?.setMarkedCount(this.allSelectedRows.length);
    },
    getAllSelectedRows() {
      const rowsSelected = [];
      this.gridApi.forEachNode((node, index) => {
        if (node.selected) {
          rowsSelected.push(node);
        }
      });
      return rowsSelected;
    },
    successfulBulkUpdate() {
      setTimeout(() => this.gridApi.onFilterChanged(), 1000);
    },
    clickManualEditFilterButton() {
      this.isManuallyEditedFilter = !this.isManuallyEditedFilter;
      setTimeout(() => this.gridApi.onFilterChanged(), 100);
    },
    clickAutomaticEditFilterButton() {
      this.isAutomaticallyEditedFilter = !this.isAutomaticallyEditedFilter;
      setTimeout(() => this.gridApi.onFilterChanged(), 100);
    },
    applyEditFilters() {
      // Apply edit filters from subheader
      const filterState = [
        {
          state: this.isManuallyEditedFilter,
          odataFilter: '(lastModifiedUserId ne null and bearbeitungStatus ne null)',
        },
        {
          state: this.isAutomaticallyEditedFilter,
          odataFilter:
            '(lastModifiedUserId eq null and bearbeitungDataSetByCore eq true and bearbeitungStatus ne null)',
        },
      ];

      const editedFilterOdataString =
        '(' +
        filterState
          .filter(filter => filter.state)
          .map(filter => filter.odataFilter)
          .flat()
          .join(' or ') +
        ')';
      if (!this.isAutomaticallyEditedFilter && !this.isManuallyEditedFilter) {
        this.$store.commit('flugverfuegbarkeit/' + RESET_EDITED_FILTER);
      } else {
        this.$store.commit('flugverfuegbarkeit/' + SET_EDITED_FILTER, editedFilterOdataString);
      }
    },
    regionsmanagerAnsichtChanged() {
      if (this.regionsmanagerAnsichtCheckbox) {
        // disable regionsmanager floating filter
        this.columnDefs = this.columnDefs.map(col => {
          if (col.field === 'regionsmanager') {
            return { ...col, floatingFilter: false };
          }
          return col;
        });
        // set regionsmanager filter model
        this.queryForUser();
      } else {
        // enable regionsmanager floating filter
        this.columnDefs = this.columnDefs.map(col => {
          if (col.field === 'regionsmanager') {
            return { ...col, floatingFilter: true };
          }
          const regionsmanagerFilter = this.gridApi?.getFilterInstance('regionsmanager');
          regionsmanagerFilter.setModel({});
          return col;
        });
        // reset regionsmanager filter model
        const regionsmanagerFilter = this.gridApi?.getFilterInstance('regionsmanager');
        regionsmanagerFilter.setModel({});
        this.gridApi.onFilterChanged();
      }
    },
    regionFilterClicked($event) {
      const id = $event.target.id;
      if (this.regionFilterSelected === null || this.regionFilterSelected !== id) {
        this.regionFilterSelected = id;
      } else if (this.regionFilterSelected === id) {
        this.regionFilterSelected = null;
      }

      // apply ag grid filter
      if (this.regionFilterSelected) {
        const regionsmanagerFilter = this.gridApi?.getFilterInstance('reisetermin.reise.region');
        regionsmanagerFilter.setModel({ values: [this.regionFilterSelected] });
        this.gridApi.onFilterChanged();
      } else {
        const regionsmanagerFilter = this.gridApi?.getFilterInstance('reisetermin.reise.region');
        regionsmanagerFilter.setModel({});
        this.gridApi.onFilterChanged();
      }
    },
    changeRegionFilterInstance(selectedRegions) {
      if (!this.gridApi) return;
      const regionsFilter = this.gridApi.getFilterInstance('reisetermin.reise.region');

      if (!regionsFilter) return;

      if (selectedRegions.length > 0) {
        regionsFilter.setModel({ values: selectedRegions });
      } else {
        regionsFilter.setModel({});
      }
      this.gridApi.onFilterChanged();
    },
    createRowData(fver) {
      const exportData = [];

      const verfuegbarkeit = value => {
        return value === 'Akzeptiert'
          ? 'Akzeptiert'
          : value === 'VerfuegbarkeitGeschaffen'
          ? 'Verfuegbarkeit geschaffen'
          : value === 'VerfuegbarkeitNichtGeschaffen'
          ? 'Verfuegbarkeit nicht geschaffen'
          : value === null
          ? ''
          : value;
      };

      const bearbeitung =
        fver.lastModifiedUserId === null && fver.bearbeitungStatus !== null ? 'Automatisch' : 'Manuell';

      const abreisedatum = formatDateWithoutHours(fver.reisetermin?.abreisedatum);
      const rueckflugdatum = formatDateWithoutHours(fver.reisetermin?.hotelendUndRueckflugdatum);

      let aufpreis = '';
      if (fver.aufpreis !== null) {
        aufpreis = `${fver.aufpreis}€`;
      }

      const prioritaet = value => {
        return value === 0 ? 'A' : value === 1 ? 'B' : value === 2 ? 'C' : value === 3 ? 'D' : value;
      };

      let fehlermeldung = '';
      if (fver.abfragefehler?.typ) {
        fehlermeldung = fver.abfragefehler.typ.replaceAll('_', ' ').substring(0, 14) + '...';
      }

      const einkaufsart = translateEinkaufsartOptions(fver.reisetermin?.flugeinkauf?.einkaufsart);

      let tageBisRelease = '';
      if (fver.reisetermin?.releasedatum) {
        tageBisRelease = differenceInDays(parseISO(fver.reisetermin.releasedatum), new Date()).toString();
      }

      exportData.push([
        fver.reisetermin?.reiseterminkuerzel,
        verfuegbarkeit(fver.bearbeitungStatus),
        bearbeitung,
        fver.reisetermin?.istZusatztermin === true ? 'Zusatztermin' : 'Kein Zusatztermin',
        fver.reisetermin?.reise?.reisekuerzel ?? '',
        abreisedatum,
        rueckflugdatum,
        fver.deutscherAbflughafenIataCode ?? '',
        fver.status ?? '',
        aufpreis,
        prioritaet(fver.reisetermin?.reise?.prioritaet),
        fver.reisetermin?.umsatzpotenzial
          ? `${new Intl.NumberFormat('en-DE').format(fver.reisetermin.umsatzpotenzial)}€`
          : '-',
        fver.reisetermin?.metadata?.transferszenarioHin?.substring(0, 2) ?? '',
        fver.reisetermin?.metadata?.transferszenarioRueck?.substring(0, 2) ?? '',
        fehlermeldung,
        fver.flugstammHinflug ?? '',
        fver.zielflughafenIataCode ?? '',
        fver.abflughafenIataCode ?? '',
        fver.reisetermin?.pax?.ist ?? '',
        fver.reisetermin?.garantiert === true ? 'Ja' : 'Nein',
        einkaufsart,
        tageBisRelease,
        fver.reisetermin?.thLangstrecke ? `${fver.reisetermin.thLangstrecke}€` : '-',
        fver.reisetermin?.gueltigerSaisonpreis?.thMaxLangstrecke
          ? `${fver.reisetermin.gueltigerSaisonpreis.thMaxLangstrecke}€`
          : '-',
        fver.zimmertyp ?? '',
        fver.reisetermin?.reise?.reisekuerzel
          ? getRegionsmanagerOfReisekuerzel(fver.reisetermin.reise.reisekuerzel)
          : '',
        fver.abfragedatum ? format(new Date(fver.abfragedatum), 'dd.MM.yyyy HH:mm') : '',
        fver.blankImportedDateUtc ? format(new Date(fver.blankImportedDateUtc), 'dd.MM.yyyy HH:mm') : '',
        fver.akzeptanzgrund
          ? allAkzeptanzgruende.find(ag => ag.enum === fver.akzeptanzgrund)?.label || ''
          : '',
        fver.ursache ? allUrsachen.find(u => u.enum === fver.ursache)?.label || '' : '',
      ]);

      return exportData;
    },
  },
};
</script>
<style scoped>
:deep(.ag-theme-alpine) {
  font-family: 'Poppins';
}

:deep(.ag-cell[col-id='farben']) {
  padding-left: 0px !important;
  border: none;
}

:deep(.ag-cell[col-id='bearbeitung']) {
  padding-left: 0px !important;
  padding-right: 0px !important;
  border: none;
}

:deep(.ag-header-cell[aria-colindex='1']),
:deep(.ag-header-cell[aria-colindex='2']) {
  padding-left: 4px;
  padding-right: 4px;
}

:deep(.ag-theme-alpine .ag-header-cell) {
  font-weight: 500;
  font-size: 14px;
}

.icon-button {
  height: 32.52px;
}
</style>
